export const LANDING_PAGE_URL = process.env.LANDING_PAGE_URL || '';
const REDIRECTABLE_URLS_STRING = process.env.REDIRECTABLE_URLS
export const REDIRECTABLE_URLS = REDIRECTABLE_URLS_STRING
  ? REDIRECTABLE_URLS_STRING.split(',').map(v => v.trim())
  : [];
export const ACCOUNT_API_HOST = process.env.ACCOUNT_API_HOST || '';
export const RECAPTCHA_CLIENT_KEY = process.env.RECAPTCHA_CLIENT_KEY || '';
